import {bool, datetime, Schema} from 'simpli-web-sdk'
import AuditByDeliveryResponse from '@/model/response/AuditByDeliveryResponse'
import RenderLabelValue from '@/components/render/RenderLabelValue.vue'
import * as Helpers from '@/helpers'

export default (model: AuditByDeliveryResponse): Schema => ({
    idCargaPk: {
        content: model.carga && model.carga.idCargaPk,
    },

    nroNotaFiscal: {
        content: model.carga && Helpers.formatScientificNumber(model.carga.nroNotaFiscal),
    },

    dataCriacao: {
        content: model.carga && datetime(model.carga.dataCriacao),
    },

    dataBaixaSistema: {
        content: model.carga && datetime(model.carga.dataBaixaSistema),
    },

    statusAuditoria: {
        content: [
            {
                component: RenderLabelValue,
                props: {
                    value: model.carga && model.carga.auditoriaStatus,
                    tagClass: model.carga && model.carga.auditoriaStatusTagClass,
                },
            },
            {
                component: RenderLabelValue,
                props: {
                    label: model.translateColumn('auditoriaLocalEntrega'),
                    value: model.carga && model.carga.auditoriaStatus,
                    tagClass: model.carga && model.carga.auditoriaStatusTagClass,
                },
            },
        ],
        textContent: model.carga && model.carga.auditoriaStatus,
    },

    statusNotificacaoAuditoria: {
        content: model.carga && model.carga.cargaInfo && model.carga.cargaInfo.statusNotificacaoAuditoria &&
            model.carga.cargaInfo.statusNotificacaoAuditoria.nome,
    },

    dataEnvio: {
        content: model.emailAuditoriaEnvio && datetime(model.emailAuditoriaEnvio.dataEnvio),
    },
})
